// @flow
import { Store } from '@homie/flux';
import * as LocationActionTypes from 'action_types/LocationActionTypes';
import Dispatcher from 'dispatcher';
import _ from 'lodash';

const COUNTRIES_CHANGE = 'countries_change';
const STATES_CHANGE = 'states_change';

let _countries = [];
let _states = [];

class LocationStore extends Store {
  constructor(): void {
    super();
    Dispatcher.register(this._actionsHandler);
  }

  getCountries = (): any => {
    return _.values(_countries);
  };

  getStates = (): any => {
    return _states;
  };

  getCountryById = (id: string): any => {
    return _countries[id];
  };

  addCountriesChangeListener = (callback: () => void) => {
    this.on(COUNTRIES_CHANGE, callback);
  };

  addStatesChangeListener = (callback: number => void, index?: any = '') => {
    this.on(STATES_CHANGE + index, () => {
      callback(index);
    });
  };

  removeCountriesChangeListener = (callback: () => void) => {
    this.removeListener(COUNTRIES_CHANGE, callback);
  };

  removeStatesChangeListener = (callback: number => void) => {
    this.removeListener(STATES_CHANGE, callback);
  };

  _setCountries = (countries: {}[]) => {
    _countries = {};
    _.forEach(countries, country => {
      _countries[`${country.alpha2}`] = country;
    });
  };

  _setStates = (states: {}[]) => {
    _states = states;
  };

  _emitCountriesChange = () => {
    this.emit(COUNTRIES_CHANGE);
  };

  _emitStatesChange = (index: number) => {
    const event = STATES_CHANGE + index;
    this.emit(event);
  };

  _actionsHandler = (action: any) => {
    switch (action.type) {
      case LocationActionTypes.SAVE_COUNTRIES: {
        this._setCountries(action.countries);
        this._emitCountriesChange();
        break;
      }
      case LocationActionTypes.SAVE_STATES_BY_COUNTRY: {
        this._setStates(action.states);
        this._emitStatesChange(action.index);
        break;
      }
    }
    this.notify();
  };
}

export default new LocationStore();
